var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    clipPath: "url(#clip0_1398_35614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.9065 17.3067C25.9598 16.8801 25.9998 16.4534 25.9998 16.0001C25.9998 15.5467 25.9598 15.1201 25.9065 14.6934L28.7198 12.4934C28.9731 12.2934 29.0398 11.9334 28.8798 11.6401L26.2131 7.02675C26.0531 6.73341 25.6931 6.62675 25.3998 6.73342L22.0798 8.06675C21.3865 7.53342 20.6398 7.09342 19.8265 6.76008L19.3198 3.22675C19.2798 2.90675 18.9998 2.66675 18.6665 2.66675H13.3331C12.9998 2.66675 12.7198 2.90675 12.6798 3.22675L12.1731 6.76008C11.3598 7.09342 10.6131 7.54675 9.91979 8.06675L6.59979 6.73342C6.29312 6.61342 5.94645 6.73341 5.78645 7.02675L3.11979 11.6401C2.94645 11.9334 3.02645 12.2934 3.27979 12.4934L6.09312 14.6934C6.03979 15.1201 5.99979 15.5601 5.99979 16.0001C5.99979 16.4401 6.03979 16.8801 6.09312 17.3067L3.27979 19.5067C3.02645 19.7067 2.95979 20.0667 3.11979 20.3601L5.78645 24.9734C5.94645 25.2667 6.30645 25.3734 6.59979 25.2668L9.91979 23.9334C10.6131 24.4667 11.3598 24.9067 12.1731 25.2401L12.6798 28.7734C12.7198 29.0934 12.9998 29.3334 13.3331 29.3334H18.6665C18.9998 29.3334 19.2798 29.0934 19.3198 28.7734L19.8265 25.2401C20.6398 24.9067 21.3865 24.4534 22.0798 23.9334L25.3998 25.2668C25.7065 25.3867 26.0531 25.2667 26.2131 24.9734L28.8798 20.3601C29.0398 20.0667 28.9731 19.7067 28.7198 19.5067L25.9065 17.3067ZM15.9998 20.6667C13.4265 20.6667 11.3331 18.5734 11.3331 16.0001C11.3331 13.4267 13.4265 11.3334 15.9998 11.3334C18.5731 11.3334 20.6665 13.4267 20.6665 16.0001C20.6665 18.5734 18.5731 20.6667 15.9998 20.6667Z",
    fill: "#2D3748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1398_35614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingEquipment);
export default __webpack_public_path__ + "static/media/settingEquipment.cddc2df17cd3b28eef840e69bb14a2b6.svg";
export { ForwardRef as ReactComponent };